export default __webpack_public_path__ + "static/media/icon_privacy_home_choice_icon-2.ef3774b2.svg";